/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Collections_Status_LoadingInputs */

const id_collections_status_loading = /** @type {(inputs: Collections_Status_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Memuat...`)
};

const ms_collections_status_loading = /** @type {(inputs: Collections_Status_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Memuat...`)
};

const da_collections_status_loading = /** @type {(inputs: Collections_Status_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Indlæser...`)
};

const de_collections_status_loading = /** @type {(inputs: Collections_Status_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lädt...`)
};

const en_us2_collections_status_loading = /** @type {(inputs: Collections_Status_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loading...`)
};

const es_es2_collections_status_loading = /** @type {(inputs: Collections_Status_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cargando...`)
};

const es_mx2_collections_status_loading = /** @type {(inputs: Collections_Status_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cargando...`)
};

const fil_collections_status_loading = /** @type {(inputs: Collections_Status_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Naglo-load...`)
};

const fr_collections_status_loading = /** @type {(inputs: Collections_Status_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chargement…`)
};

const it_collections_status_loading = /** @type {(inputs: Collections_Status_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caricamento...`)
};

const hu_collections_status_loading = /** @type {(inputs: Collections_Status_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Betöltés...`)
};

const nl_collections_status_loading = /** @type {(inputs: Collections_Status_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Laden...`)
};

const no_collections_status_loading = /** @type {(inputs: Collections_Status_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Laster...`)
};

const pl_collections_status_loading = /** @type {(inputs: Collections_Status_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ładowanie...`)
};

const pt_br2_collections_status_loading = /** @type {(inputs: Collections_Status_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carregando...`)
};

const pt_collections_status_loading = /** @type {(inputs: Collections_Status_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A carregar...`)
};

const ro_collections_status_loading = /** @type {(inputs: Collections_Status_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se încarcă...`)
};

const fi_collections_status_loading = /** @type {(inputs: Collections_Status_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ladataan...`)
};

const sv_collections_status_loading = /** @type {(inputs: Collections_Status_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Laddar...`)
};

const vi_collections_status_loading = /** @type {(inputs: Collections_Status_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đang tải...`)
};

const tr_collections_status_loading = /** @type {(inputs: Collections_Status_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yükleniyor...`)
};

const cs_collections_status_loading = /** @type {(inputs: Collections_Status_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Načítání...`)
};

const bg_collections_status_loading = /** @type {(inputs: Collections_Status_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Зареждане...`)
};

const ru_collections_status_loading = /** @type {(inputs: Collections_Status_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Загрузка...`)
};

const uk_collections_status_loading = /** @type {(inputs: Collections_Status_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Завантаження...`)
};

const ar_collections_status_loading = /** @type {(inputs: Collections_Status_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`جارٍ التحميل...`)
};

const hi_collections_status_loading = /** @type {(inputs: Collections_Status_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`लोड हो रहा है...`)
};

const th_collections_status_loading = /** @type {(inputs: Collections_Status_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`กำลังโหลด...`)
};

const ja_collections_status_loading = /** @type {(inputs: Collections_Status_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`読み込み中...`)
};

const zh_cn2_collections_status_loading = /** @type {(inputs: Collections_Status_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`加载中...`)
};

const zh_hant1_collections_status_loading = /** @type {(inputs: Collections_Status_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`載入中...`)
};

const ko_collections_status_loading = /** @type {(inputs: Collections_Status_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`로딩 중...`)
};

/**
* | output |
* | --- |
* | "Loading..." |
*
* @param {Collections_Status_LoadingInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const collections_status_loading = /** @type {((inputs?: Collections_Status_LoadingInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Collections_Status_LoadingInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_collections_status_loading(inputs)
	if (locale === "ms") return ms_collections_status_loading(inputs)
	if (locale === "da") return da_collections_status_loading(inputs)
	if (locale === "de") return de_collections_status_loading(inputs)
	if (locale === "en-US") return en_us2_collections_status_loading(inputs)
	if (locale === "es-ES") return es_es2_collections_status_loading(inputs)
	if (locale === "es-MX") return es_mx2_collections_status_loading(inputs)
	if (locale === "fil") return fil_collections_status_loading(inputs)
	if (locale === "fr") return fr_collections_status_loading(inputs)
	if (locale === "it") return it_collections_status_loading(inputs)
	if (locale === "hu") return hu_collections_status_loading(inputs)
	if (locale === "nl") return nl_collections_status_loading(inputs)
	if (locale === "no") return no_collections_status_loading(inputs)
	if (locale === "pl") return pl_collections_status_loading(inputs)
	if (locale === "pt-BR") return pt_br2_collections_status_loading(inputs)
	if (locale === "pt") return pt_collections_status_loading(inputs)
	if (locale === "ro") return ro_collections_status_loading(inputs)
	if (locale === "fi") return fi_collections_status_loading(inputs)
	if (locale === "sv") return sv_collections_status_loading(inputs)
	if (locale === "vi") return vi_collections_status_loading(inputs)
	if (locale === "tr") return tr_collections_status_loading(inputs)
	if (locale === "cs") return cs_collections_status_loading(inputs)
	if (locale === "bg") return bg_collections_status_loading(inputs)
	if (locale === "ru") return ru_collections_status_loading(inputs)
	if (locale === "uk") return uk_collections_status_loading(inputs)
	if (locale === "ar") return ar_collections_status_loading(inputs)
	if (locale === "hi") return hi_collections_status_loading(inputs)
	if (locale === "th") return th_collections_status_loading(inputs)
	if (locale === "ja") return ja_collections_status_loading(inputs)
	if (locale === "zh-CN") return zh_cn2_collections_status_loading(inputs)
	if (locale === "zh-Hant") return zh_hant1_collections_status_loading(inputs)
	return ko_collections_status_loading(inputs)
});
export { collections_status_loading as "collections.status.loading" }